'use strict';

var _config = require('config');

// Function to add prefix to links.
var link = function link(_link) {
  if (typeof __PREFIX_LINKS__ !== 'undefined' && __PREFIX_LINKS__ !== null && __PREFIX_LINKS__ && _config.config.linkPrefix !== null) {
    return _config.config.linkPrefix + _link;
  } else {
    return _link;
  }
};

module.exports = {
  link: link
};


// WEBPACK FOOTER //
// ../~/gatsby/dist/isomorphic/gatsby-helpers.js